module.exports = __webpack_public_path__ + "img/i_nav_list_new_off.53ef76e6.svg";